import { Component, OnInit, Input } from '@angular/core';

@Component({
standalone: false,
  selector: 'dialog-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {
  @Input () info = '';
  constructor() { }

  ngOnInit() {
  }

}
